import $ from 'jquery';

export default class PremiumBannerBenefitToggle {
  constructor({ $element: $element }) {
    this.$toggle = $element;
    this.$origin = this.$toggle.data('origin');
  }

  init() {
    this.$toggle.click(this.toggleBenefitPage.bind(this));
  }

  toggleBenefitPage() {
    if (this.$origin == 'banner') {
      $('.js-watchpage-premium-banner-title.hide').addClass('keep-hidden');
      $('.js-watchpage-premium-banner').children().addClass('hide');
      $('.js-benefit').removeClass('hide');
    } else {
      $('.js-watchpage-premium-banner').children().removeClass('hide');
      $('.js-watchpage-premium-banner-title.keep-hidden').addClass('hide');
      $('.js-benefit').addClass('hide');
    }
  }
}
